
export default function ExperienceSection() {
  const items = [
    { n: '01', title: 'Sharp Edges', text: 'Clean lines around beds, paths, and driveways with careful trimming and edging.' },
    { n: '02', title: 'Careful Cleanup', text: 'Clippings blown, paths swept, and the property left ready for you to enjoy.' },
    { n: '03', title: 'Healthy Lawn', text: 'Mowing heights and weed control planned around Ballarat seasons.' },
    { n: '04', title: 'Prompt Quotes', text: 'Quotes back quickly with practical recommendations and clear next steps.' },
  ];

  return (
    <section className="dark-green-bg py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5 reveal">
          <p className="section-label mb-4 text-[#D98A00]">Our Standard</p>
          <h2 className="text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold leading-[1.05] mb-6 text-white">
            Consistent care from the first quote to the final cleanup.
          </h2>
          <p className="text-white/80 text-lg leading-relaxed max-w-md">
            Modern lawn &amp; garden maintenance should feel organised, professional, and
            easy to manage. Every visit is built around clear communication, careful
            finishing details, and a tidy handoff.
          </p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {items.map((it, i) => (
            <div key={it.n} className="reveal relative rounded-lg border border-white/15 bg-white/[0.04] backdrop-blur-sm p-6" style={{ transitionDelay: `${i * 90}ms` }}>
              <div className="absolute top-0 left-6 right-6 h-[3px] bg-gradient-to-r from-[#D98A00] to-[#B86F00]" />
              <div className="text-[#D98A00] font-bold text-sm tracking-wider mb-3">{it.n}</div>
              <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>{it.title}</h3>
              <p className="text-white/75 text-sm leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
